<template>
    <div>
        <v-row justify="center">
            <v-col md="10" sm="12"><div class="scholarship-criteria">SCHOLARSHIP CRITERIA</div></v-col>
        </v-row>
        <v-row justify="center" style="margin-bottom: 100px">
            <v-col  md="10" sm="12">
                <v-row justify="space-between">
                    <v-col style="text-align:left">
                        <AttendanceIcon class="scholarship-criteria-shape"/>
                        <div class="bold scholarship-criteria-text">School Attendance</div>
                        <div class="scholarship-criteria-text">GO Scholars need an attendance rate of 90% or higher. If your attendance is lower than this, we want to know why.</div>
                    </v-col>
                    <v-col style="text-align:left">
                        <AspirationIcon class="scholarship-criteria-shape"/>
                        <div class="bold scholarship-criteria-text">Aspiration</div>
                        <div class="scholarship-criteria-text">We are looking for students who work hard. You don’t have to get the best marks but you have to have a good attitude. We want to see you making an effort with your studies.</div>
                    </v-col>
                    <v-col style="text-align:left">
                        <CulturalIdentityIcon class="scholarship-criteria-shape"/>
                        <div class="bold scholarship-criteria-text">Cultural Identity</div>
                        <div class="scholarship-criteria-text">GO Scholars have a strong cultural identity or a deep desire to know more. We look for evidence of this deep desire in your activities and engagement with community.</div>
                    </v-col>
                    <v-col style="text-align:left">
                        <GivingBackIcon class="scholarship-criteria-shape"/>
                        <div class="bold scholarship-criteria-text">Giving Back</div>
                        <div class="scholarship-criteria-text">At GO, we care about other people, our communities and our families. We want students who give back to others and we look for examples of how you do this.</div>
                    </v-col>
                    <v-col style="text-align:left">
                        <FinancialNeedIcon class="scholarship-criteria-shape"/>
                        <div class="bold scholarship-criteria-text">Financial Need</div>
                        <div class="scholarship-criteria-text">We don’t means test our scholarships or ask for tax papers, but instead look for financial need in your application.</div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import FinancialNeedIcon from '../../public/criteria_financialNeed.svg';
import AspirationIcon from '../../public/criteria_Aspiration.svg';
import CulturalIdentityIcon from '../../public/criteria_culturalIdentity.svg';
import GivingBackIcon from '../../public/criteria_givingBack.svg';
import AttendanceIcon from '../../public/criteria_Attendance.svg';


export default {
    components:{
        FinancialNeedIcon,
        AspirationIcon,
        CulturalIdentityIcon,
        GivingBackIcon,
        AttendanceIcon,
    },
}
</script>
<style lang="scss" scoped>
.scholarship-criteria {
  width: 316px;
  height: 31px;
  font-family: Dosis;
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 3.2px;
  color: black;
  margin-top: 30px;
}

.scholarship-criteria-shape
{
    height: 75px;
    margin-bottom: 10px;
}

.scholarship-criteria-text
{
    font-family: Hind;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: black
}

.bold {
    font-weight: bold;
}

</style>
